/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Agent_Readiness_Check_QuickstartInputs */

const en_directory_agent_readiness_check_quickstart = /** @type {(inputs: Directory_Agent_Readiness_Check_QuickstartInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quickstart`)
};

const zh_directory_agent_readiness_check_quickstart = /** @type {(inputs: Directory_Agent_Readiness_Check_QuickstartInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`快速开始`)
};

/**
* | output |
* | --- |
* | "Quickstart" |
*
* @param {Directory_Agent_Readiness_Check_QuickstartInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_agent_readiness_check_quickstart = /** @type {((inputs?: Directory_Agent_Readiness_Check_QuickstartInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Agent_Readiness_Check_QuickstartInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_agent_readiness_check_quickstart(inputs)
	return zh_directory_agent_readiness_check_quickstart(inputs)
});
export { directory_agent_readiness_check_quickstart as "directory.agent_readiness.check.quickstart" }